import ActionTypes from "../../enums/ActionTypes"
import { createAPIRequestReducer } from "../api"

export default createAPIRequestReducer(ActionTypes.PLANNING_OBJECTS_PROJECT_DETAILS_LOAD)
